import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e27afcf"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-backdrop" }, null, -1))
const _hoisted_2 = { class: "ReportPage" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Actualizar Anaqueles", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = {
  class: "row g-3 needs-validation",
  novalidate: ""
}
const _hoisted_6 = { class: "col-md-4" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom02",
  class: "form-label"
}, "Anaquel", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "valid-feedback" }, " Looks good! ", -1))
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom02",
  class: "form-label"
}, "Cara", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "valid-feedback" }, " Looks good! ", -1))
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom04",
  class: "form-label"
}, "Status", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "A" }, "Activo", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "I" }, "Inactivo", -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, " Please select a valid state. ", -1))
const _hoisted_18 = { class: "col-12" }

import { Ref, ref } from 'vue'
import { useDateTimeStore } from '@/store/dateTimeStore';
import axios from 'axios'
import { UrlGlobal } from '@/store/dominioGlobal';
import { userGlobalStore } from '@/store/userGlobal';


export default /*#__PURE__*/_defineComponent({
  __name: 'UpLogAnaquel',
  props: {
    btnLaUp: Boolean,
    almacen: String,
    area: String,
    status: String,
    anaquel: String,
    cara: String,

},
  emits: ['updLaProps'],
  setup(__props, { emit: __emit }) {

const dateTimeStore = useDateTimeStore();
const userStore = userGlobalStore();

const dUrl = UrlGlobal()

//props y emits ----------------------------------------------------------------
const props = __props
const emits = __emit
const handleClick = () => {
    emits("updLaProps", !props.btnLaUp)
}
//------------------------------------------------------------------------------

//variables reactivas para el formulario----------------------------------------
const almacen = ref(props.almacen)
const area = ref(props.area)
let anaquel = ref(props.anaquel)
let cara = ref(props.cara)
let status = ref(props.status)
 

//------------------------------------------------------------------------------
const handleSubmit = async () => {
    try {
        const response = await axios.post(dUrl.urlGlobal +'/api2/update/', {
            table: 'loganaquel', 
            filters: { almacen: props.almacen, area: props.area, anaquel: props.anaquel , cara: props.cara}, // Filtro para identificar el registro a actualizar
            data: { anaquel: anaquel.value, cara: cara.value, status: status.value, modificado_por:userStore.globalUser, fecha_status:dateTimeStore.formattedDate,
            hora_status:dateTimeStore.formattedTime } // Datos a actualizar
        })
        console.log(response.data)
        emits("updLaProps", !props.btnLaUp)
    } catch (error) {
        console.error("Error actualizando datos:", error)
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("form", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "validationCustom02",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(anaquel) ? (anaquel).value = $event : anaquel = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, _unref(anaquel)]
          ]),
          _hoisted_8
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "validationCustom02",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(cara) ? (cara).value = $event : cara = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, _unref(cara)]
          ]),
          _hoisted_11
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            id: "validationCustom04",
            required: "",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(status) ? (status).value = $event : status = $event))
          }, _hoisted_16, 512), [
            [_vModelSelect, _unref(status)]
          ]),
          _hoisted_17
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("button", {
            class: "btn btn-secondary me-2",
            type: "button",
            style: {"background-color":"#24292F"},
            onClick: _cache[3] || (_cache[3] = ($event: any) => (handleClick()))
          }, "Cancelar"),
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "button",
            style: {"background-color":"#001982"},
            onClick: handleSubmit
          }, "Enviar")
        ])
      ])
    ])
  ], 64))
}
}

})